var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInapp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "55px",
    height: "55px",
    viewBox: "0 0 55 55",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "31A0DBFB-4B8C-4848-9DD8-F3800F602BEB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "path-1",
    cx: 22.356187,
    cy: 22.5,
    rx: 22.356187,
    ry: 22.5
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-17.9%",
    y: "-13.3%",
    width: "135.8%",
    height: "135.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard---Final-Template-Arun",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Helix-Template-1.9B",
    transform: "translate(-103.000000, -1331.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-246",
    transform: "translate(108.000000, 1334.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval-2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#40B75F",
    strokeWidth: 2,
    fill: "#40B75F",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.6117424,33.046875 L20.6912879,33.046875 C20.3319129,33.046875 20.0378788,32.7502441 20.0378788,32.3876953 L20.0378788,31.9482422 C20.0378788,31.5856934 20.3319129,31.2890625 20.6912879,31.2890625 L24.6117424,31.2890625 C24.9711174,31.2890625 25.2651515,31.5856934 25.2651515,31.9482422 L25.2651515,32.3876953 C25.2651515,32.7502441 24.9711174,33.046875 24.6117424,33.046875 Z M31.3636364,11.0742188 L31.3636364,33.9257812 C31.3636364,35.3814697 30.1929451,36.5625 28.75,36.5625 L16.5530303,36.5625 C15.1100852,36.5625 13.9393939,35.3814697 13.9393939,33.9257812 L13.9393939,11.0742188 C13.9393939,9.61853027 15.1100852,8.4375 16.5530303,8.4375 L28.75,8.4375 C30.1929451,8.4375 31.3636364,9.61853027 31.3636364,11.0742188 Z M29.6212121,11.0742188 C29.6212121,10.5908203 29.2291667,10.1953125 28.75,10.1953125 L16.5530303,10.1953125 C16.0738636,10.1953125 15.6818182,10.5908203 15.6818182,11.0742188 L15.6818182,33.9257812 C15.6818182,34.4091797 16.0738636,34.8046875 16.5530303,34.8046875 L28.75,34.8046875 C29.2291667,34.8046875 29.6212121,34.4091797 29.6212121,33.9257812 L29.6212121,11.0742188 Z",
    id: "Shape",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInapp);
export default __webpack_public_path__ + "static/media/inapp.7046a37e.svg";
export { ForwardRef as ReactComponent };